// Angular puts ng-invalid on the host of every control and every group of controls (a group of fields, a list of rows). The
// form itself is left out, and what is scrolled to is the most specific one that is not valid (see below).
const INVALID_SELECTOR = '.ng-invalid:not(form)';

const FOCUSABLE = 'input, textarea, mat-select, [role="slider"]';

function isShown(element: HTMLElement): boolean {
  // The steps that are not open stay in the page but are not shown, so they are skipped.
  const check = (element as HTMLElement & { checkVisibility?: (options: object) => boolean }).checkVisibility;
  return check ? check.call(element, { visibilityProperty: true }) : element.getClientRects().length > 0;
}

// Scrolls to the first control that is not valid, and puts the cursor in it, so the person can see what is missing. Where a
// group of fields or rows is invalid, it is that group that is found, not the whole list around it, and the cursor goes to its
// first field. Returns false when nothing is invalid.
export function scrollToFirstInvalid(root: ParentNode = document): boolean {
  const invalid = Array.from(root.querySelectorAll<HTMLElement>(INVALID_SELECTOR)).filter(isShown);
  const target = invalid.find((element) => !invalid.some((other) => other !== element && element.contains(other)));

  if (!target) {
    return false;
  }

  // Start of the field, a little below the top of the page, so the header does not cover it and a tall group is read from its top.
  const anchor = (target.closest('mat-form-field') as HTMLElement | null) ?? target;
  anchor.style.scrollMarginTop = '96px';
  anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });

  const field = target.matches(FOCUSABLE) ? target : target.querySelector<HTMLElement>(FOCUSABLE);
  field?.focus({ preventScroll: true });
  return true;
}
